module.exports = __webpack_public_path__ + "img/olga sofranova-_DSC6187.5d02fea2.jpg";